import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

export interface SpeakerTravelItem {
  speaker_id: string;
  first_name: string;
  last_name: string;
  full_name: string;
  distance_miles: number | null;
  display_value: string;
}

export interface EstimatedTravelResponse {
  speaker_travels: SpeakerTravelItem[];
  is_virtual: boolean;
}

@Injectable()
export class EventEstimatedTravelService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/estimated_travel`);
  }
}
